export const Home = () => {
    return (
        <>
            <div>Home</div>
        </>
    );
};
